import { jsx as c } from "react/jsx-runtime";
import { createContext as i, useState as m, useCallback as f, useMemo as x } from "react";
const M = i(void 0), I = ({
  children: n,
  container: t
}) => {
  const [s, l] = m([]), r = f((o, a = !0) => {
    l(a ? (e) => e.includes(o) ? [...e] : [...e, o] : (e) => e.includes(o) ? e.filter((d) => d !== o) : [...e]);
  }, []), u = x(
    () => ({
      opened: s,
      container: t,
      showModal: r
    }),
    [t, s, r]
  );
  return /* @__PURE__ */ c(M.Provider, { value: u, children: n });
};
export {
  M as IressModalContext,
  I as IressModalProvider
};
